import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { toDate, toDateFromPtBr } from '@/modules/core/utils/formats';

export const getPaginatedUsuariosData = async(options) => {
  const params = getParams(options);
  params.pagina = options.page;
  params.porPagina = 10;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/usuarios?${new URLSearchParams(params).toString()}`);
  return response.data;
};

export const getAllUsuariosData = async(options) => {
  const params = getParams(options);
  params.pagina = 1;
  params.porPagina = 1000000;
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(`admin/usuarios?${new URLSearchParams(params).toString()}`);
  return response.data.dados.map((data) => [
    `"${data.nome}"`,
    `"${data.email}"`,
    `"${data.empresa}"`,
    `"${toDate(data.dataHoraUltimoLogin)}"`,
    `"${data.emailConfirmado}"`,
    `"${data.quantidadeReenvioEmail}"`,
    `"${data.perfilUsuario?.nome || ''}"`,
    `"${data.ativo ? 'Sim' : 'Não'}"`,
    `"${data.sincronizarTudo}"`,
  ]);
};

const getParams = (options) => ({
  ordem: options.order,
  ordenarPor: options.sort,
  pesquisar: options.search,
  dataHoraUltimoLoginInicial: toDateFromPtBr(options.lastLoginInitialDate),
  dataHoraUltimoLoginFinal: toDateFromPtBr(options.lastLoginEndDate),
});

export const AtualizarSincronizarTudo = async(usuario) => {
  const httpClient = authenticatedHttpClientFactory();
  try {
    const response = await httpClient.patch('/usuarios/sincronizarTudo', usuario);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
